import { gql } from '@apollo/client';
import { Spinner } from 'components/spinner';
import {
  Categories,
  useSearchCategoriesLazyQuery,
  SearchCategoriesQueryResult,
} from 'lib/graphql-generated';
import { Dispatch, SetStateAction } from 'react';
import { MultiSelect, MultiSelectData } from './multi-select';

const SEARCH_CATEGORIES = gql`
  query SearchCategories($search: String) {
    categories(where: { name: { _ilike: $search } }) {
      name
    }
  }
`;

export type CategorySelectorValue = MultiSelectData<
  SearchCategoriesQueryResult['data']['categories'][0]
>;

export const SerializeCategories = (
  categories: Partial<Categories>[]
): CategorySelectorValue[] => {
  const arr =
    categories?.map(
      (c) =>
        c && {
          label: c.name,
          key: c.name,
          data: { name: c.name },
        }
    ) ?? [];

  return arr.filter((obj) => obj);
};

interface Props {
  label?: string;
  value: CategorySelectorValue[];
  setValue: Dispatch<SetStateAction<MultiSelectData<Partial<Categories>>[]>>;
  singleSelect?: boolean;
  className?: string;
}

export function CategoriesSelector({
  label,
  value,
  setValue,
  singleSelect = false,
  className,
}: Props) {
  const [search, { data, loading, error }] = useSearchCategoriesLazyQuery({
    fetchPolicy: 'no-cache',
  });

  const handleSearch = (value) => {
    if (value.length >= 2) {
      search({ variables: { search: `%${value}%` } });
    }
  };

  return (
    <MultiSelect
      className={className}
      id={label?.replace(' ', '') || 'tagSelector'}
      label={label}
      onSearch={handleSearch}
      placeholder='Search by category name'
      searchResults={data?.categories.map((c) => ({
        label: c.name,
        key: c.name,
        data: c,
      }))}
      values={value}
      setValues={setValue}
      notFoundContent={loading ? <Spinner /> : null}
      singleSelect={singleSelect}
    />
  );
}
